import { render, staticRenderFns } from "./point-of-sale-history.vue?vue&type=template&id=0e193ac8"
import script from "./point-of-sale-history.vue?vue&type=script&lang=js"
export * from "./point-of-sale-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports